import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Container, Grid } from "@mui/material";
import { Path } from "../../../static/Constants";
import { colors } from "../../../theme";
import Pdf from "../../Autobet_whitepaper.pdf";

import FooterBrand from "./components/FooterBrand";
import FooterNavCol from "./components/FooterNavCol";
import FooterContact from "./components/FooterContact";
import FooterSocials from "./components/FooterSocials";
import FooterBottom from "./components/FooterBottom";

import "./FooterStyle.css";

/**
 * Route check to exclude Footer on dashboard / admin / creator screens
 */
export const isDashboardPath = (pathname = "") => {
  const path = (pathname || "").toLowerCase();
  return (
    path.startsWith("/admin") ||
    path.startsWith("/admins") ||
    path.startsWith("/creator") ||
    path.startsWith("/creators") ||
    path.startsWith("/org") ||
    path.startsWith("/profile")
  );
};

const FooterStrip = () => {
  const location = useLocation();
  const pathname =
    location?.pathname ||
    (typeof window !== "undefined" ? window.location.pathname : "");

  if (isDashboardPath(pathname)) {
    return null;
  }

  // Lottery Games Navigation with Renamed Game Titles
  const gamesLinks = [
    { label: "SpinBET", path: Path.Spinnerlottery },
    { label: "RocketBET", path: Path.allmissilelottery },
    { label: "MineBET", path: Path.allminelottery },
    { label: "MegaBET", path: Path.alllottery },
    { label: "Digital Gift Cards", path: Path.allgiftcards },
    { label: "Draw Results", path: Path.result },
  ];

  // Ecosystem & Resources Navigation
  const ecosystemLinks = [
    { label: "Lottery Creator Hub", path: Path.org },
    { label: "Become a Creator", path: Path.registerasorg },
    { label: "Latest News", path: Path.news },
    { label: "About AutoBET", path: Path.about },
    { label: "Help Center & FAQ", path: Path.help },
    { label: "Autobet Whitepaper", href: Pdf, isExternal: true },
  ];

  return (
    <Box
      component="footer"
      className="autobet-footer-root"
      sx={{
        backgroundColor: colors.sidebar.bg,
        color: colors.slate[200],
        pt: 0,
        position: "relative",
      }}
    >
      {/* Top Gradient Accent Line */}
      <div className="autobet-footer-top-accent" />

      {/* Ambient Lighting Glows */}
      <Box
        className="autobet-footer-glow-left"
        sx={{ backgroundColor: colors.alpha.primary[12] }}
      />
      <Box
        className="autobet-footer-glow-right"
        sx={{ backgroundColor: colors.alpha.red[12] }}
      />

      {/* Main Footer Content Container */}
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 1,
          px: { xs: 3, sm: 4, md: 6, lg: 8 },
        }}
      >
        {/* Multi-Column Grid */}
        <Grid
          container
          spacing={{ xs: 4, sm: 4, md: 3, lg: 5 }}
          sx={{ pt: { xs: 5, md: 7 }, pb: { xs: 5, md: 6 } }}
        >
          {/* 1. Brand & Trust Badges */}
          <Grid item xs={12} sm={12} md={4} lg={3.5}>
            <FooterBrand />
          </Grid>

          {/* 2. Lottery Games Navigation */}
          <Grid item xs={6} sm={6} md={2.5} lg={2}>
            <FooterNavCol title="Games" links={gamesLinks} />
          </Grid>

          {/* 3. Ecosystem & Platform Navigation */}
          <Grid item xs={6} sm={6} md={2.5} lg={2.5}>
            <FooterNavCol title="Ecosystem" links={ecosystemLinks} />
          </Grid>

          {/* 4. Contact Details & Social Community */}
          <Grid item xs={12} sm={12} md={3} lg={4}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3.5 }}>
              <FooterContact />
              <FooterSocials />
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Bar: Copyright, Legal Links, Scroll To Top */}
        <FooterBottom />
      </Container>
    </Box>
  );
};

export default FooterStrip;
